
namespace GeniuzPOS.Inventory {

    @Serenity.Decorators.registerClass()
    export class IcStockDisassembleGrid extends Serenity.EntityGrid<IcStockDisassembleRow, any> {
        protected getColumnsKey() { return IcStockDisassembleColumns.columnsKey; }
        protected getDialogType() { return IcStockDisassembleDialog; }
        protected getIdProperty() { return IcStockDisassembleRow.idProperty; }
        protected getInsertPermission() { return IcStockDisassembleRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStockDisassembleRow.localTextPrefix; }
        protected getService() { return IcStockDisassembleService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'add-button'), 1)

            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: IcStockSetAssembleService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
            
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );            
            return buttons;
        }
    }
}